module.exports = __webpack_public_path__ + "fonts/feed-video.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blur_admin/src/assets/img/theme/icon/feed/feed-video.svg
// module id = 1296
// module chunks = 2